<nav class="top-nav-container">
  <md-navbar></md-navbar>
</nav>
<router-outlet />
